import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { DocumentsData } from '@/features/ui/DocumentsData';

import { buildDocumentsDataPreview } from '@/shared/lib/helpers/documentsDataPreviewHelper';
import { FormTextArea, Grid, StepControlPanel } from '@/shared/ui';

import { useERZDocumentTypes } from '@/modules/erz/helpers';

import { ALLOWED_ADDITIONAL_DOC_TYPES, MAX_DOCUMENTS_NUMBER } from '../../lib/constants';
import { ReapplicationDocumentsSchema } from '../../model/types';

export const ReapplicationDocuments: React.FC<StepProps> = ({ currentRequestId, prev, next, onStepDraftSave }) => {
  const { control } = useFormContext<ReapplicationDocumentsSchema>();

  const { data: documentTypeEntities = [] } = useERZDocumentTypes({
    allowedDocumentTypeCodes: ALLOWED_ADDITIONAL_DOC_TYPES,
  });
  const safeRequestId = currentRequestId ?? '';

  return (
    <>
      <FormBlock title="Дані для поновлення">
        <DocumentsData
          withUploader
          autofillType={false}
          autofillInfo={false}
          documentTypeEntities={documentTypeEntities ?? []}
          maxDocumentsCount={MAX_DOCUMENTS_NUMBER}
          name="reapplicationDocuments"
          request_id={safeRequestId}
          onSaveDraft={onStepDraftSave}
        />
      </FormBlock>
      <FormBlock title="Додаткові відомості">
        <FormTextArea control={control} name="additional_info" label="Додаткові відомості" />
      </FormBlock>
      <StepControlPanel prev={prev} next={next} />
    </>
  );
};

export const ReapplicationDocumentsPreview: React.FC = () => {
  const { getValues } = useFormContext<ReapplicationDocumentsSchema>();
  const { reapplicationDocuments, additional_info } = getValues();

  const { docsBlocks, infoRows } = buildDocumentsDataPreview(reapplicationDocuments, additional_info);

  return docsBlocks.length > 0 || infoRows.length ? (
    <FormBlock title="Дані для поновлення">
      {docsBlocks}
      {infoRows.length ? <Grid title="Додаткові відомості" data={infoRows} /> : null}
    </FormBlock>
  ) : (
    <></>
  );
};
